export enum TicketDescriptionDisplayMode {
  Disabled = 0,
  IconOnly = 1,
  DescriptionOnly = 2
}
